module.exports = __webpack_public_path__ + "img/36-End split easily.bf0a2a81.png";